const handleAwcdp = () => {
    const awcdpRadios = document.querySelectorAll('.awcdp-radio');
    const awcdpToggles = document.querySelectorAll('.awcdp-toggle');

    if (awcdpRadios.length > 0) {
        awcdpRadios.forEach(radioDiv => {
            radioDiv.setAttribute('tabindex', 0);

            radioDiv.addEventListener('keydown', e => {
                if (e.key === 'Enter') {
                    e.preventDefault();
                    const label = radioDiv.querySelector('.awcdp-radio-label');
                    if (label) label.click();
                }
            });
        });
    }

    if (awcdpToggles.length > 0) {
        awcdpToggles.forEach(item => {
            item.setAttribute('tabindex', 0);
            item.addEventListener('keydown', e => {
                if (e.key === 'Enter') {
                    item.click();
                }
            });
        });
    }
};

if (
    document.readyState === 'complete' ||
    (document.readyState !== 'loading' && !document.documentElement.doScroll)
) {
    handleAwcdp();
} else {
    document.addEventListener('DOMContentLoaded', handleAwcdp);
}
